import { render, staticRenderFns } from "./contentMenu.vue?vue&type=template&id=f6f0bbc4&lang=html"
import script from "./contentMenu.vue?vue&type=script&lang=js"
export * from "./contentMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports